import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { VideoViewPopupComponent } from 'src/app/features-modules/category/video-view-popup/video-view-popup.component';
import { PremiumInvitesComponent } from 'src/app/features-modules/personalise/components/premium-invites/premium-invites.component';
import { SharedService } from 'src/app/services/shared.service';
import { environment } from 'src/environments/environment';
declare var $: any;

interface Video {
  VideoId: number;
  GifLink: string;
  ThumbnailImage: string;
  NumberOfPhotos: number;
  NumberOfViews: number;
  NameEnglish: string;
  Currrency: string;
  FinalPrice: string;
  FinalPriceAED: string;
  FinalPriceINR: string;
  Price: string;
  PriceAED: string;
  PriceINR: string;
  TemplateId: any;
  Duration: string;
  DisplayType: number,
  TemplateName: String,
  VideoEditorType: number;
}

@Component({
  selector: 'app-video-post',
  templateUrl: './video-post.component.html',
  styleUrls: ['./video-post.component.css']
})
export class VideoPostComponent implements OnInit {
  @Input() video: Video;
  assetURL = environment.assetURL;
  @Input() loader: string = this.assetURL + '/assets/images/GIF/tenor.gif';
  @Input() height: number = 50;
  @Input() width: number = 50;
  @Input() image: string;
  siteURL = environment.siteURL;
  constructor(public ngbModel: NgbModal, private _router: Router, public sharedService: SharedService, private modalService: NgbModal,) {
    this.isLoading = true;
  }

  isLoading: boolean;

  hideLoader() {
    this.isLoading = false;
  }

  ngOnInit(): void {
    // this.video.TemplateName = this.video?.TemplateName?.replace("Project","Project_");
  }

  public openVideoPage(item) {
    let encryptedqueryparams: { videoId: any; };
    encryptedqueryparams = {
      videoId: item?.VideoId
    };
    this._router.navigate([`/${item.NameEnglish.replace(/ +/g, "-")}/video/${this.sharedService.encryptData(JSON.stringify(encryptedqueryparams))}`]);
  }

  public loadImgSrc(imageId) {
    $("#img" + imageId).attr("src", `${this.assetURL}/${this.video?.GifLink}`);
    $("#play" + imageId).hide();
  }
  public mouseoutEvent(imageId) {
    $("#play" + imageId).show();
  }
  GoToPersonalize(item) {
    let encryptedqueryparams: { videoId: any; };
    let videoEditor = this.video.VideoEditorType == 1 ? 'video' : 'video-editor';
    encryptedqueryparams = {
      videoId: item?.VideoId
    };
    const route = `/preview/${item.NameEnglish.replace(/ +/g, "-")}/${videoEditor}/${this.sharedService.encryptData(JSON.stringify(encryptedqueryparams))}`;
    window.open(route, '_blank');
  }

  premiumInvites(item, isFromCategory = false) {
    if (item?.DisplayType == 2) {
      let encryptedqueryparams: { videoId: any; };
      encryptedqueryparams = {
        videoId: item.VideoId
      };
      const modelRef = this.modalService.open(PremiumInvitesComponent, {
        size: 'lg',
        windowClass: 'p-dialog'
      });
      modelRef.componentInstance.isFromPayment = false;
      modelRef.componentInstance.addOnId = 1;
      modelRef.componentInstance.videoPath = `${environment.rsvpURL}/invitation/envelope/${this.sharedService.encryptData(JSON.stringify(encryptedqueryparams))}`;
      modelRef.componentInstance.isFromCategory = isFromCategory;
      modelRef.componentInstance.videoId = item.VideoId;
      modelRef.componentInstance.nameEnglish = item.NameEnglish;
      modelRef.result.then((data: boolean) => {
        if (data) {
          let encryptedqueryparams: { templateId: any };
          encryptedqueryparams = {
            templateId: item?.TemplateId
          };
          // this._router.navigate([`/personalise/${item.NameEnglish.replace(/ +/g, "-")}/video/${this.sharedService.encryptData(JSON.stringify(encryptedqueryparams))}`]);
        }
      });
    }
    else {
      this.viewVideo(item);
    }
  }

  viewVideo(item) {
    const modelRef = this.ngbModel.open(VideoViewPopupComponent, {
      size: 'lg',
      windowClass: 'modal-holder',
      centered: true
    });
    modelRef.componentInstance.videoData = item;
    modelRef.result.then((data: boolean) => {
      if (data) {
        let encryptedqueryparams: { videoId: any };
        encryptedqueryparams = {
          videoId: item?.VideoId
        };
        const route = `/preview/${item.NameEnglish.replace(/ +/g, "-")}/video/${this.sharedService.encryptData(JSON.stringify(encryptedqueryparams))}`;
        window.open(route, '_blank');

      }
    });
  }
}
